import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState } from 'react';

import PaymentInformation from './PaymentInformation';
import { styles } from './styles';

const UpdatePaymentInformation = ({ className }) => {
	const [isPaymentModalOpen, setModalPaymentModal] = useState(false);

	const togglePaymentModalVisibility = () => setModalPaymentModal(prev => !prev);
	const handleUpdatePaymentInfo = () => {
		togglePaymentModalVisibility();
	};

	return (
		<Box sx={className}>
			<Button fullWidth variant={'outlined'} sx={styles.btnUpdate} onClick={handleUpdatePaymentInfo}>
				Update Payment Information
			</Button>
			<PaymentInformation isOpen={isPaymentModalOpen} handleClose={togglePaymentModalVisibility} />
		</Box>
	);
};

export default UpdatePaymentInformation;
